// extracted by mini-css-extract-plugin
module.exports = {"timeGroup":"Activities_timeGroup__3sBIh","timeGroupHeader":"Activities_timeGroupHeader__3PE6e"};